/**
 * Publication badge: DWH #E2D3C0 with black text, DWT black with white text.
 */
export default function PubBadge({ pub }) {
  const styles = pub === "dwt"
    ? "bg-black text-white"
    : pub === "dwh"
      ? "bg-[#e2d3c0] text-black"
      : "bg-white text-black border border-[#c19872]";
  return (
    <span
      className={`inline-block px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded-full ${styles}`}
      data-testid={`pub-badge-${pub}`}
    >
      {(pub || "").toUpperCase()}
    </span>
  );
}
